import type { AIModel, AIProvider } from '@ekorank/shared'

interface ModelDisplay {
  label: string
  color: string
  family: AIProvider
}

export const MODEL_DISPLAY: Record<AIModel, ModelDisplay> = {
  'claude-haiku':         { label: 'Claude Haiku',     color: '#c0c1ff', family: 'anthropic'  },
  'claude-sonnet':        { label: 'Claude Sonnet',    color: '#a4a5ff', family: 'anthropic'  },
  'claude-opus':          { label: 'Claude Opus',      color: '#8a8bff', family: 'anthropic'  },
  'gpt-4o-mini':          { label: 'GPT-4o mini',      color: '#4cd7f6', family: 'openai'     },
  'gpt-4.1':              { label: 'GPT-4.1',          color: '#2bb8d9', family: 'openai'     },
  'gemini-2.5-flash':     { label: 'Gemini 2.5 Flash', color: '#d0bcff', family: 'google'     },
  'gemini-2.5-pro':       { label: 'Gemini 2.5 Pro',   color: '#b89cff', family: 'google'     },
  'perplexity-sonar':     { label: 'Perplexity Sonar', color: '#a5f3fc', family: 'perplexity' },
  'perplexity-sonar-pro': { label: 'Perplexity Pro',   color: '#67e8f9', family: 'perplexity' },
}

export function modelLabel(model: string): string {
  return MODEL_DISPLAY[model as AIModel]?.label ?? model
}

export function modelColor(model: string): string {
  return MODEL_DISPLAY[model as AIModel]?.color ?? '#908fa0'
}
